import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errors.length > 0)?_c(VAlert,{attrs:{"type":"error"}},[_c('ul',_vm._l((_vm.displayedErrors),function(error,index){return _c('li',{key:index},[_vm._v(" "+_vm._s(error.message)+" ")])}),0)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }